import { FC, MouseEvent } from 'react';

import styled from 'styled-components';

const TYPES = [
  { text: 'All Types', value: -1 },
  { text: 'Login Banner', value: 0 },
  { text: 'Welcome Popup', value: 1 },
  { text: 'Dashboard Banner', value: 2 },
  { text: 'Tournament Banner', value: 3 },
  { text: 'Gamification Badge', value: 4 },
];

export type FilterProps = {
  query: string;
  updateQuery: (query: string) => void;
  submit: (e: MouseEvent) => void;
  filterType: string;
  updateFilterType: (value: string) => void;
};

const Container = styled.div`
  display: inline-block;
  margin-left: 20px;
  position: relative;
  top: -7px;
`;

const Input = styled.input`
  border: 1px solid;
  padding: 8px;
  border-radius: 5px;
`;

const Select = styled.select`
  border: 1px solid;
  padding: 8px;
  border-radius: 5px;
  margin-left: 10px;
`;

const Button = styled.button(({ theme }) => {
  return `
    display: inline-flex;
    align-items: center;
    border-radius: 0.25rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    font-weight: ${theme.type.weight.bold};
    margin-left: 10px;
    background-color: ${theme.color.secondary.regular};
    color: ${theme.color.grayscale[1000]};
    transition: 0.5s;
    &:hover {
      background-color: ${theme.color.secondary.light};
    }
  `;
});

const printTypeOptions = () => {
  return TYPES.map((type) => {
    return <option value={type.value}>{type.text}</option>;
  });
};

const FilterSection: FC<FilterProps> = ({ query, updateQuery, submit, filterType, updateFilterType }) => {
  return (
    <Container>
      <Input
        placeholder="Communication Name"
        value={query}
        onChange={(e) => {
          updateQuery(e.target.value);
        }}
      ></Input>
      <Select
        value={filterType}
        onChange={(e) => {
          updateFilterType(e.target.value);
        }}
      >
        {printTypeOptions()}
      </Select>
      <Button
        onClick={(e) => {
          submit(e);
        }}
      >
        Filter
      </Button>
    </Container>
  );
};

export default FilterSection;
